import React, { useState } from 'react'
import { Lock, ArrowRight } from 'lucide-react'
import OndsDashboard from './OndsDashboard'
import { ACCESS } from '../config/ondsConfig'
import { DeskProvider, ONDS_DESK } from '../deskContext'
import '../onds.css'

const isUnlocked = () => sessionStorage.getItem(ACCESS.storageKey) === 'true'

export default function OndsGate({ desk = ONDS_DESK }) {
  const [unlocked, setUnlocked] = useState(isUnlocked)
  const [code, setCode] = useState('')
  const [shake, setShake] = useState(false)

  const submit = (e) => {
    e.preventDefault()
    const entered = code.trim().toLowerCase()
    if (ACCESS.codes.includes(entered)) {
      sessionStorage.setItem(ACCESS.storageKey, 'true')
      sessionStorage.setItem(ACCESS.codeStorageKey, entered)
      setUnlocked(true)
      return
    }
    setShake(true)
    setCode('')
    setTimeout(() => setShake(false), 500)
  }

  if (unlocked) {
    return (
      <DeskProvider desk={desk}>
        <div className={`onds-scope onds-grid-noise ${desk.themeClass}`}>
          <OndsDashboard />
        </div>
      </DeskProvider>
    )
  }

  return (
    <DeskProvider desk={desk}>
    <div className={`onds-scope onds-grid-noise ${desk.themeClass} flex items-center justify-center px-4`}>
      <form
        onSubmit={submit}
        className="onds-card w-full max-w-md p-8 onds-fade-up"
        style={shake ? { animation: 'onds-shake 0.4s' } : undefined}
      >
        <style>{`@keyframes onds-shake{0%,100%{transform:translateX(0)}20%,60%{transform:translateX(-8px)}40%,80%{transform:translateX(8px)}}`}</style>

        <div className="flex flex-col items-center text-center mb-6">
          <div
            className="w-16 h-16 rounded-2xl flex items-center justify-center mb-4 onds-pulse-ring"
            style={{ backgroundColor: 'var(--onds-accent)', color: '#0a0e17' }}
          >
            <Lock className="h-7 w-7" />
          </div>
          <h1 className="text-2xl font-bold">{desk.ticker} Committee Desk</h1>
          <p className="text-sm text-[var(--onds-text-dim)] mt-1">Restricted terminal. Enter your access code to convene the committee.</p>
        </div>

        <input
          autoFocus
          type="password"
          value={code}
          onChange={(e) => setCode(e.target.value)}
          placeholder="Access code"
          className="w-full px-4 py-3 rounded-xl outline-none text-center tracking-[0.3em] font-semibold mb-4"
          style={{ backgroundColor: 'var(--onds-surface)', border: '1px solid var(--onds-border)', color: 'var(--onds-text)' }}
        />

        <button
          type="submit"
          className="w-full flex items-center justify-center gap-2 px-4 py-3 rounded-xl font-bold transition"
          style={{ backgroundColor: 'var(--onds-accent)', color: '#0a0e17' }}
        >
          Continue <ArrowRight className="h-5 w-5" />
        </button>
      </form>
    </div>
    </DeskProvider>
  )
}
